<template>
  <div class="Checkbox">
    <button
      class="Checkbox__check"
      :class="[get_checkClass, get_disabledClass]"
      @click="toToggle"
      type="button"
      :disabled="props.disabled"
    >
      <CheckMark class="Checkbox__check-mark" />
    </button>
    <span class="Checkbox__label" v-if="props.label" @click="toToggle">{{ props.label }}</span>
    <input
      class="Checkbox__input"
      type="checkbox"
      :checked="isChecked"
      :name="props.name"
      :disabled="props.disabled"
      @change="$emit('change', isChecked)"
    />
  </div>
</template>

<script setup>
  import { defineProps, defineEmits, computed, ref, watch } from 'vue';
  import { Props } from "@/Shared/UI/Fields/TextInput/scripts/props";
  //-------------------------------------
  import CheckMark from '@shared/UI/SVG/CheckMark.vue';
  //-------------------------------------
  const props = defineProps(Props());
  const emit = defineEmits(['change', 'update:modelValue']);
  //-------------------------------------
  const isChecked = ref(props.modelValue ?? false);
  //-------------------------------------
  //Определить активный класс для checkbox
  const get_checkClass = computed(() => (isChecked.value ? 'Checkbox__check--active' : ''));
  //Определить активный класс для checkbox
  const get_disabledClass = computed(() => {
    if (!props.disabled) return '';
    return isChecked.value
      ? 'Checkbox__check--disabled-checked'
      : 'Checkbox__check--disabled';
  });
  //-------------------------------------
  // Переключить состояние чекбокса
  const toToggle = () => {
    if (props.disabled) return;
    isChecked.value = !isChecked.value;
    emit('update:modelValue', isChecked.value);
    emit('change', isChecked.value);
  };
  //-------------------------------------
  // Следим за входным значением (для синхронизации)
  watch(() => props.modelValue, (newVal) => {
    isChecked.value = newVal;
  });
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>
